"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _OtherRegionsSwiper.OtherRegionsSwiper;
  }
});
var _OtherRegionsSwiper = require("./OtherRegionsSwiper");